/** The keys a dropped row of a node's health answers is reported by. */

import { z } from 'zod';

const PathKeySchema = z.object({ path: z.string() });
const RuleKeySchema = z.object({ type: z.string(), counter: z.string() });

/** A description's row is named by its path. */
export function getCounterPathKey(row: unknown): string | null {
    const key = PathKeySchema.safeParse(row);
    return key.success ? key.data.path : null;
}

/** A rule's row is named by the problem it raises and the counter it watches. */
export function getRuleKey(row: unknown): string | null {
    const key = RuleKeySchema.safeParse(row);
    return key.success ? `${key.data.type}@${key.data.counter}` : null;
}
